// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22Co4","title":"styles_title__3j9MG"};